import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import { fDateTimeWithTimezone, fMonthDay } from "../../../../../utils/formatTime";
import { listItemStyles, getItemDescription } from "./orderLogHelper";
import Iconify from "../../../../../reusable-components/iconify";

OrderLogTrackingInfo.propTypes = {
  logItem: PropTypes.object,
  setHighlightedRow: PropTypes.func,
  items: PropTypes.array,
}

export default function OrderLogTrackingInfo({logItem, setHighlightedRow, items}) {

  const titleStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
    wordBreak: 'normal',
    cursor: 'pointer'
  };

  const orderItem = logItem.itemQuantityId ? items?.find((item) => item.id === logItem.itemQuantityId) : null;
  const trackingInfoItems = logItem?.trackingInfoItems || [];

  const descRef = useRef(null);
  const [isDescOverflowing, setIsDescOverflowing] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);

  useEffect(() => {
    const descEl = descRef.current;
    if (descEl) setIsDescOverflowing(descEl.scrollWidth > descEl.clientWidth);
  }, []);

  return <Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }} onClick={() => setHighlightedRow(logItem.itemQuantityId)}>
      <Tooltip title={orderItem?.description || ''} disableHoverListener={!isDescOverflowing} placement="top">
        <Typography ref={descRef} variant="body" sx={titleStyle} color="info.main">
          Tracking Info added
        </Typography>
      </Tooltip>
      <Box sx={{ flexGrow: 1 }} />
      {!!trackingInfoItems.length && (
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setOpenDetails((prev) => !prev);
          }}
          sx={{ p: 0.25, color: 'info.main' }}
        >
          <Iconify icon={openDetails ? 'mdi:chevron-down' : 'mdi:chevron-right'} width={16} height={16} />
        </IconButton>
      )}
    </Box>
    <Typography variant="body2" color="black">
      {fDateTimeWithTimezone(logItem.dateAdded)}
    </Typography>

    {/* Rendered while collapsed (just hidden) so log search can match the details */}
    {!!trackingInfoItems.length && (
      <Box sx={{ pl: 1, mb: 0.5, mt: 0.5, display: openDetails ? undefined : 'none' }}>
        {trackingInfoItems.map((trackingInfoItem, idx) => (
          <Box key={`${trackingInfoItem.trackingNumber}-${idx}`} sx={{minWidth: 0}}>
            <Typography
              variant="caption"
              color="info.main"
              sx={{
                textDecoration: 'underline',
                cursor: 'pointer',
                display: 'block',
                width: '100%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%'
              }}
              onClick={() => setHighlightedRow(trackingInfoItem.itemQuantityId)}
            >
              {getItemDescription(trackingInfoItem.itemQuantityId, items)}
            </Typography>
            <ul style={{ paddingLeft: '20px', margin: 0, marginBottom: 4 }}>
              <li style={listItemStyles}>
                Tracking Number: {trackingInfoItem.trackingNumber}
              </li>
              <li style={listItemStyles}>
                Sent From: {trackingInfoItem.sentFrom}
              </li>
              {trackingInfoItem.trackingUrl && <li style={listItemStyles}>
                Tracking URL: {' '}
                  <a href={trackingInfoItem.trackingUrl} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                    {trackingInfoItem.trackingUrl}
                  </a>
              </li>}
              <li style={listItemStyles}>
                Amount Shipped: {trackingInfoItem.amountShipped}
              </li>
              <li style={listItemStyles}>
                Shipped Date: {fMonthDay(trackingInfoItem.shippedDate)}
              </li>
            </ul>
          </Box>
        ))}
      </Box>
    )}
  </Box>;
}
